/**
 * Portal alerts (#6632). reportAlert(code, subject, details) sends a portal.* code to the back end's
 * send-alert, which decides who hears about it: the page never picks recipients, tier or HTML.
 * Alerts raised in the browser are reliability alerts; security alerts come from the back end.
 * portal.dev.* codes are Debug tier, so only developers who subscribed to them get them.
 * Fire-and-forget: a failed alert never breaks the calling feature. Repeats are throttled server-side
 * (an hour per code, subject, client and user), so callers don't need their own dedup.
 */
import { sendAlertURL } from './api-urls.js';

function toText(v) {
	const s = typeof v === 'string' ? v : JSON.stringify(v);
	return String(s ?? '')
		.replace(/<br\s*\/?>/gi, '\n')
		.replace(/<\/(p|div|li|tr)>/gi, '\n')
		.replace(/<[^>]+>/g, '')
		.replace(/&nbsp;/g, ' ')
		.trim();
}

export function reportAlert(code, subject, details) {
	try {
		const fields = details && typeof details === 'object' && !Array.isArray(details) ? details : { Details: details };
		const body = {
			code,
			subject: toText(subject || code),
			details: Object.fromEntries(Object.entries(fields).map(([k, v]) => [k, toText(v)])),
			client: typeof client !== 'undefined' ? client : '',
			userid: typeof authedUser !== 'undefined' ? authedUser : '',
			cookie: typeof cookie !== 'undefined' ? cookie : window.cookie || '',
			page: window.location.pathname,
		};
		axios.post(sendAlertURL, JSON.stringify(body)).catch((err) => console.error('reportAlert failed:', err));
	} catch (err) {
		console.error('reportAlert failed:', err);
	}
}

// A bulk pass (e.g. the JMS Payment Scanner in edit.js, one getPayments() per holder) can silence
// data-gap alerts while it runs.
let devAlertsSuppressed = false;

export function suppressDevAlerts() {
	devAlertsSuppressed = true;
}

export function restoreDevAlerts() {
	devAlertsSuppressed = false;
}

/** A data gap the page noticed (a failed match, a holder missing data). A developer's own checks pass their code
 * (e.g. portal.dev.requests), which send-alert sends only to whoever subscribed to it. */
export function sendDevAlert(subject, message, code = 'portal.dev.data_gap') {
	if (!devAlertsSuppressed) reportAlert(code, subject, message);
}
